import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FeedbackModal } from "./FeedbackModal";

export function FeedbackButton() {
  const [showModal, setShowModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    // setShowModal(true);        // uncomment to open internal feedback form
    window.open("https://gentell.freshdesk.com/support/solutions", "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Button 
        variant="primary" 
        onClick={handleClick}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
        onFocus={() => setIsExpanded(true)}
        onBlur={() => setIsExpanded(false)}
        className={`btn-floating-feedback ${isExpanded ? "expanded" : "collapsed"}`}
        aria-label="Provide feedback"
      >
        <i className="flaticon2-chat-1"></i>
        <span className="feedback-text">Feedback</span>
      </Button>
      
      <FeedbackModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
}
